import { makeStableReturn } from '@/services/helpers/helpers-without-framework';
import {
    ApiErrorObject,
} from '@/services';
import { Certificate } from './ssl-certificate-edit';
import * as Types from '@/types';
import { ContractPeriodWord } from '@/configuration';
import {
    ProductPriceNew,
    ProductPriceParams,
    ProductPriceNewRequests,
} from '@/logic/product-price-new';

export interface CertificateRenewHotline {
    changedCsr: (csrInput: string) => void,
    decodedCsr: Csr,
    csrInput: string,
    priceInfo: RenewPriceInfo
}

export interface Csr {
    valid: boolean,
    decodeFailed: boolean,
    decodedData: Types.SslApi.CSR
    isWildcard: boolean,
}

// or maybe requests for renew, reissue, revoke
export type SslCertificateEditRenewRequests = {
    decodeCsr: (csr: string) => Promise<Types.SslApi.DecodeCsrResult>, // TYPING
    renew: (id: string, csr?: string, validationType?: string) => Promise<any> // check request
    handleRenewResponse: (res: any) => void,
    priceFromProductCode: (params: ProductPriceParams) => Promise<any>
}

export type RenewPriceInfo = { state: 'loading' } | {
    state: 'loaded',
    amountScaled10000: number,
    currency: string,
    billingPeriod: ContractPeriodWord,
} | { state: 'unknown' };

export class SslCertificateEditCallcenter {
    public productPrice: ProductPriceNew;
    public csrInput = '';
    public csr: Csr = {
        valid: false,
        decodeFailed: false,
        decodedData: {
            country: '',
            domainName: '',
            eccType: '',
            emailAddress: '',
            keyLength: undefined,
            keyType: '',
            locality: '',
            organization: '',
            organizationUnit: '',
            state: ''
        },
        isWildcard: false
    };
    public certificate: Certificate;
    public productPriceRequests: ProductPriceNewRequests = {
        getPriceFromProductCode: this.requests.priceFromProductCode
    }

    constructor(
        private requests: SslCertificateEditRenewRequests,
    ) {
        this.productPrice = new ProductPriceNew(
            this.productPriceRequests,
        )
    }

    public getRenewHotline = makeStableReturn(
        (): CertificateRenewHotline => {
            return Object.freeze(
                {
                    changedCsr: this.checkCsr,
                    decodedCsr: this.csr,
                    csrInput: this.csrInput,
                    priceInfo: this.getRenewPriceInfo()
                }
            );
        }
    )

    public get decodedCsr(): Csr {
        return this.csr;
    }

    public csrFailed = (error: ApiErrorObject) => {
        this.csr.decodedData = null;

        if (error.code === 50002) {
            this.csr.valid = false;
        } else {
            this.csr.decodeFailed = true;
        }
    };

    public csrSucceeded = (response: Types.SslApi.DecodeCsrResult): [] => {
        this.csr.decodedData = response.csr;
        this.csr.isWildcard = response.csr.domainName.startsWith('*.');
        return [];
    };


    public checkCsr = (csrInput: string): void => {
        this.csrInput = csrInput;
        this.csr.valid = true;
        this.csr.decodeFailed = false;

        if ([undefined, null].indexOf(csrInput) >= 0) {
            return;
        }
        this.requests.decodeCsr(csrInput)
        .then(
            response => {
                if (response.errors && response.errors[0]) {
                    return Promise.reject(response.errors[0]);
                }
                return response;
            }
        )
        .then(this.csrSucceeded, this.csrFailed);
    };

    public renewCertificate = (id: string) => {
        return this.requests.renew(id, this.csrInput).then(
            this.requests.handleRenewResponse,
            Promise.reject
        )
    };

    public reissueCertificate = () => {};

    public revokeCertificate = () => {};

    public getRenewPriceInfo(): RenewPriceInfo {
        return this.productPrice.getProductPrice(this.certificate.productCode);
    }
}
